import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorInfoComponent } from '../../containers/vendor-info/vendor-info.component';
import { SharedModule } from 'src/app/shared.module';
import {
  InviteEmailsModalModule,
  MySuppliersAnalyticsPerformanceModule,
  SideNavComponent,
  SideNavModule,
  SustainmentButtonModule
} from 'sustainment-component';
import { TopNavComponent, TopNavModule } from 'sustainment-component';
import { VendorInfoRoutingModule } from './vendor-info-routing.module';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RegistrationModule } from '../registration/registration.module';
import { UserProblemsComponent } from 'src/app/components/features/registration/user-problems/user-problems.component';
import { MainSideNavigationComponent } from 'src/app/components/ui/main-side-navigation/main-side-navigation.component';
import { MainTopNavigationComponent } from 'src/app/components/ui/main-top-navigation/main-top-navigation.component';
import { VendorPerformanceComponent } from './vendor-performance/vendor-performance.component';

@NgModule({
  declarations: [VendorInfoComponent, VendorPerformanceComponent],
  imports: [
    CommonModule,
    SharedModule,
    InputSwitchModule,
    VendorInfoRoutingModule,
    TopNavModule,
    SideNavModule,
    InviteEmailsModalModule,
    RegistrationModule,
    SustainmentButtonModule,
    UserProblemsComponent,
    MainSideNavigationComponent,
    MainTopNavigationComponent,
    MySuppliersAnalyticsPerformanceModule
  ],
  providers: [TopNavComponent, SideNavComponent]
})
export class VendorInfoModule {}
